import React, { Component } from 'react'
import Session from 'services/session'
import ApiHelper from "services/api-helper"
import { Container, Header, Input, Form, Button, Segment } from 'semantic-ui-react'
import toastr from 'toastr'

export default class Login extends Component {
  state = {
    username: '',
    password: ''
  }
  login = () => {
    ApiHelper.PostJson('api/loginUser', {
      username: this.state.username,
      password: this.state.password
    }).then(res => {
      if (res.ok === false) {
        var text;
        switch (res.message) {
          case 'INVALID_USERNAME_OR_PASSWORD':
            text = 'Tài khoản hoặc mật khẩu không chính xác!'
            break
          default:
            text = 'Đã có lỗi xảy ra, xin thử lại sau!'
        }
        toastr.error(text)
        return
      }

      Session.setSession(res)
      // this.props.history.push("/");
      // this.props.history.go(0);

      // toastr.success(`Welcome ${res.HoTen ? res.HoTen : res.Username}`)
      setTimeout(() => {
        window.location.href = '/'
      }, 200)
    }, error => {
      toastr.error('Server đang bảo trì, xin thử lại sau!')
    })
  }
  // onKeyEnter = (e) => {
  //   if (e.key === 'Enter') {
  //     this.login();
  //   }
  // }
  handleChangeUsername = (e, { value }) => {
    this.setState({ username: value })
  }
  handleChangePassword = (e, { value }) => {
    this.setState({ password: value })
  }
  render() {
    return (
      <div>
        <div className="app flex-row align-items-center">
          <Container style={{ width: "800px" }}>
            <Segment.Group horizontal>
              <Segment style={{ padding: '35px' }}>
                <Header as='h1'>Login</Header>
                <Form>
                  <Form.Field>
                    <Input
                      icon='user'
                      iconPosition='left'
                      placeholder='Username'
                      type='text'
                      value={this.state.username}
                      onChange={this.handleChangeUsername}
                      autoFocus
                    />
                  </Form.Field>
                  <Form.Field>
                    <Input
                      icon='lock'
                      iconPosition='left'
                      placeholder='Password'
                      type='password'
                      value={this.state.password}
                      onChange={this.handleChangePassword}
                    />
                  </Form.Field>
                  <Form.Group widths='equal' style={{ paddingTop: '10px' }}>
                    <Form.Field>
                      <Button onClick={this.login} className='bg-azure'>Login</Button>
                    </Form.Field>
                    <Form.Field style={{ textAlign: 'right' }}>
                      <a href='##'>Forgot password?</a>
                    </Form.Field>
                  </Form.Group>
                </Form>
              </Segment>
              <Segment className='bg-azure text-white' textAlign='center'
                style={{ borderTopRightRadius: '3px', borderBottomRightRadius: '3px', marginBottom: '-1px', lineHeight: '200px' }}>
                <div>
                  <img alt='' src='img/logoPSC.png' style={{ maxWidth: '100%' }}></img>
                  <h4 style={{ paddingTop: '20px' }}>Website HRM</h4>
                </div>
              </Segment>
            </Segment.Group>
          </Container>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/login/index.jsx